import "./cookie-banner.scss";

let cookiebanner = document.querySelector(".cookie-banner");
let reject = cookiebanner.querySelector(".reject");
let accept = cookiebanner.querySelector(".accept");
const cookieData = document.cookie.split("; ").find((row) => row.startsWith("cookies"));
//no cookie set or old cookie or policy changed
if (!cookieData || cookieData.indexOf("--") === -1 || cookieData.split("--")[1] != cookieVersion) { 
  cookiebanner.style.display = "block";
  function acceptAction() {
    document.cookie = "cookies=accepted--" + cookieVersion + ";";
    cookiebanner.style.display = "none";
    location.reload();
  }
  function rejectAction() {
    var date = new Date();
    date.setTime(date.getTime() + (60 * 60 * 24 * 1000 * parseInt(expirationTime) )); // expires after 14 days
    var expires = date.toGMTString();
    cookiebanner.style.display = "none";
    document.cookie = "cookies=rejected--" + cookieVersion + ";expires=" + expires + ";";
    location.reload();
  }
  accept.addEventListener("click", acceptAction);
  accept.addEventListener("touchend", acceptAction);
  reject.addEventListener("click", rejectAction);
  reject.addEventListener("touchend", rejectAction);
}
